export const getRandomString = () => (Math.random() + 1).toString(36).substring(2).replace(/[0-9]/g, '');
